import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import {
    ArticleScanAutocompleteComponent,
    ArticleScanSelectedEvent,
} from '../../article-scan-autocomplete/article-scan-autocomplete.component';
import { ArtikelMenge, MAX_TOURENPLAN_ARTIKELMENGE } from '../tourenplan';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-add-article-position-dialog',
    templateUrl: './add-article-position-dialog.component.html',
    styleUrls: ['./add-article-position-dialog.component.scss'],
})
export class AddArticlePositionDialogComponent implements OnInit, AfterViewInit {
    @ViewChild('articleAuto') articleAuto: ArticleScanAutocompleteComponent;
    @ViewChild('identifikation') identifikation: MatInput;
    @ViewChild('menge') menge: MatInput;
    @ViewChild('anzahlTiere') anzahlTiere: MatInput;

    readonly maxArtikelmenge = MAX_TOURENPLAN_ARTIKELMENGE;

    currentArtikelMenge = new ArtikelMenge();

    mengeCtrl = new UntypedFormControl(null, [
        Validators.required,
        Validators.min(0.0001),
        Validators.max(MAX_TOURENPLAN_ARTIKELMENGE),
    ]);
    anzahlTiereCtrl = new UntypedFormControl();

    identifikationCtrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<AddArticlePositionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
        private readonly notification: MessageService,
    ) {}

    ngOnInit() {}

    ngAfterViewInit() {
        if (this.data) {
            this.currentArtikelMenge = this.data;
            this.initFormControls();
        }
    }

    setSelectedMaterial(event: ArticleScanSelectedEvent) {
        this.currentArtikelMenge.article = event.article;
        // Scanner-Reste nicht ins Mengenfeld schreiben lassen
        setTimeout(() => this.menge?.focus(), 80);
    }

    save() {
        this.mengeCtrl.markAsTouched();
        if (this.mengeCtrl.invalid) {
            this.notification.alertMessage(
                `Bitte eine gültige Menge zwischen 0 und ${this.maxArtikelmenge} eingeben (kein Barcode).`,
            );
            return;
        }
        this.currentArtikelMenge.menge = Number(this.mengeCtrl.value);
        this.currentArtikelMenge.anzahl_tiere = this.anzahlTiereCtrl.value;
        this.currentArtikelMenge.identifikation = this.identifikationCtrl.value;
        return this.dialogRef.close(this.currentArtikelMenge);
    }

    cancel() {
        return this.dialogRef.close(null);
    }

    private initFormControls() {
        this.articleAuto.setMaterial(this.currentArtikelMenge.article, false);
        this.mengeCtrl.setValue(this.currentArtikelMenge.menge);
        this.anzahlTiereCtrl.setValue(this.currentArtikelMenge.anzahl_tiere);
        this.identifikationCtrl.setValue(this.currentArtikelMenge.identifikation);
    }
}
